import { useCallback, useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router';
import FeedbackPopUp from '@common/components/FeedbackPopUp';

function useFeedbackPopup() {
  const [showFeedbackPopup, setShowFeedbackPopup] = useState(false);

  const openFeedbackPopup = useCallback(() => {
    setShowFeedbackPopup(true);
  }, [setShowFeedbackPopup]);

  const closeFeedbackPopup = useCallback(() => {
    setShowFeedbackPopup(false);
  }, [setShowFeedbackPopup]);

  const location = useLocation();
  useEffect(() => {
    setShowFeedbackPopup(false);
  }, [location]);

  const feedbackPopup = useMemo(() => {
    if (showFeedbackPopup) {
      return <FeedbackPopUp hide={closeFeedbackPopup} />;
    }
    return undefined;
  }, [closeFeedbackPopup, showFeedbackPopup]);

  return {
    openFeedbackPopup,
    closeFeedbackPopup,
    feedbackPopup,
  };
}

export default useFeedbackPopup;
